(() => {
  const params = new URLSearchParams(location.search);
  const titles = {"en": "2027 New Collection", "de": "Neuheiten 2027", "fr": "Nouveautés 2027", "es": "Novedades 2027", "nl": "Nieuw in 2027", "it": "Novità 2027", "zh": "2027 新款"};
  const lang = document.documentElement.lang.slice(0, 2);
  const input = document.getElementById('Q-design');
  const design = params.get('design');
  if (input && !input.value && design && /^[A-Za-z0-9-]{1,80}$/.test(design)) {
    const match = /^2027-(\d{2,})$/.exec(design);
    input.value = match ? `${titles[lang] || titles.en} ${match[1]}` : design;
  }
  document.querySelector('[data-language-picker]')?.addEventListener('change', event => {
    const target = new URL(event.target.value, location.origin);
    for (const key of ['design', 'category', 'subtype']) {
      if (params.has(key)) target.searchParams.set(key, params.get(key));
    }
    if (location.hash === '#collection') target.hash = '#collection';
    location.assign(target.href);
  });
  document.querySelectorAll('[data-collection-filter]').forEach(region => {
    if (region.dataset.bound) return;
    region.dataset.bound = 'true';
    const buttons = [...region.querySelectorAll('[data-category]')];
    const subbuttons = [...region.querySelectorAll('[data-subtype]')];
    const grid = region.querySelector('#QilaoProducts');
    const status = region.querySelector('[data-count-template]');
    const empty = region.querySelector('.q-filter-empty');
    const subnav = region.querySelector('.q-subcategory-tabs');
    const sentinel = region.querySelector('[data-scroll-sentinel]');
    const more = region.querySelector('.q-more-categories');
    const moreLabel = more?.querySelector('[data-more-label]');
    const batchSize = Number(region.dataset.batchSize) || 24;
    const abort = new AbortController();
    let category = buttons.some(b => b.dataset.category === params.get('category')) ? params.get('category') : 'all';
    let subtype = subbuttons.some(b => b.dataset.subtype === params.get('subtype')) ? params.get('subtype') : 'sub_all';
    let records = null, promise = null, matches = [], shown = 0, generation = 0, busy = false, observer = null, retryTimer = null, failures = 0;
    const closeMore = () => { if (more) more.open = false; };
    const load = () => {
      if (records) return Promise.resolve(records);
      if (!promise) {
        promise = fetch(region.dataset.catalogUrl, { credentials: 'omit', signal: abort.signal })
          .then(r => { if (!r.ok) throw new Error('Catalogue unavailable'); return r.json(); })
          .then(rows => { if (!Array.isArray(rows)) throw new Error('Invalid catalogue'); records = rows; return rows; })
          .catch(error => { promise = null; throw error; });
      }
      return promise;
    };
    const imageUrl = (url, width) => {
      const u = new URL(url, location.origin);
      if (u.hostname === 'cdn.shopify.com') u.searchParams.set('width', String(width));
      return u.href;
    };
    const createCard = p => {
      const a = document.createElement('a');
      a.className = 'q-card' + (p.category.split(' ').includes('new') ? '' : ' q-source-card'); a.href = p.href;
      a.dataset.productCategory = p.category; a.dataset.productSubtype = p.subtype;
      const photo = document.createElement('div'); photo.className = 'q-card-image';
      const img = document.createElement('img'); img.src = p.image;
      img.srcset = [240, 320, 480, 640, 960].map(w => `${imageUrl(p.image, w)} ${w}w`).join(', ');
      img.sizes = '(max-width:620px) 50vw, (max-width:1000px) 33vw, 25vw';
      img.alt = p.name; img.width = p.width; img.height = p.height; img.loading = 'lazy'; img.decoding = 'async';
      photo.append(img); const copy = document.createElement('div'); copy.className = 'q-card-copy';
      const code = document.createElement('small'); code.className = 'q-product-code'; code.textContent = p.code;
      const name = document.createElement('h3'); name.className = 'q-product-name'; name.textContent = p.name;
      copy.append(code, name); a.append(photo, copy); return a;
    };
    const watch = () => {
      sentinel.hidden = shown >= matches.length;
      if (!sentinel.hidden) observer?.observe(sentinel);
    };
    const append = () => {
      if (busy || !records || shown >= matches.length) return;
      observer?.unobserve(sentinel); busy = true;
      const fragment = document.createDocumentFragment();
      const next = Math.min(shown + batchSize, matches.length);
      for (let i = shown; i < next; i++) fragment.append(createCard(matches[i]));
      grid.append(fragment); shown = next; busy = false;
      region.dataset.shown = String(shown); sentinel.textContent = '';
      requestAnimationFrame(watch);
    };
    const updateControls = () => {
      region.dataset.activeCategory = category;
      buttons.forEach(b => b.setAttribute('aria-pressed', String(b.dataset.category === category)));
      subbuttons.forEach(b => b.setAttribute('aria-pressed', String(b.dataset.subtype === subtype)));
      subnav.hidden = category !== 'ornaments';
      const selectedExtra = more?.querySelector(`[data-category="${category}"]`);
      if (moreLabel) moreLabel.textContent = selectedExtra ? selectedExtra.textContent : moreLabel.dataset.defaultLabel;
      more?.classList.toggle('is-active', Boolean(selectedExtra));
    };
    const saveUrl = () => {
      const current = new URL(location.href);
      if (category === 'all') { current.searchParams.delete('category'); params.delete('category'); }
      else { current.searchParams.set('category', category); params.set('category', category); }
      if (category === 'ornaments' && subtype !== 'sub_all') { current.searchParams.set('subtype', subtype); params.set('subtype', subtype); }
      else { current.searchParams.delete('subtype'); params.delete('subtype'); }
      history.replaceState(null, '', current);
    };
    const update = async (save = false, preserveFirst = false) => {
      const token = ++generation; clearTimeout(retryTimer); observer?.disconnect(); updateControls();
      if (save) saveUrl();
      region.setAttribute('aria-busy', 'true'); sentinel.hidden = false; sentinel.textContent = sentinel.dataset.loadingText;
      if (!preserveFirst) grid.replaceChildren();
      try {
        const rows = await load(); if (token !== generation) return;
        matches = rows.filter(p => {
          const categories = p.category.split(' ');
          return (category === 'all' ? !categories.includes('new') : categories.includes(category)) &&
            (category !== 'ornaments' || subtype === 'sub_all' || (p.subtype || '').split(' ').includes(subtype));
        });
        failures = 0; status.textContent = status.dataset.countTemplate.replace('{count}', matches.length);
        empty.hidden = matches.length !== 0;
        if (preserveFirst && grid.children.length === Math.min(batchSize, matches.length)) {
          shown = grid.children.length; region.dataset.shown = String(shown); sentinel.textContent = ''; watch();
        } else { grid.replaceChildren(); shown = 0; append(); watch(); }
        region.setAttribute('aria-busy', 'false');
      } catch (error) {
        if (token !== generation || error.name === 'AbortError') return;
        sentinel.textContent = sentinel.dataset.errorText; region.setAttribute('aria-busy', 'false'); failures++;
        if (failures <= 3) retryTimer = setTimeout(() => update(false, preserveFirst), Math.min(1000 * 2 ** failures, 8000));
      }
    };
    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver(entries => { if (entries.some(e => e.isIntersecting)) append(); }, { rootMargin: '650px 0px', threshold: 0 });
    } else {
      window.addEventListener('scroll', () => { if (sentinel.getBoundingClientRect().top < innerHeight + 650) append(); }, { passive: true, signal: abort.signal });
    }
    buttons.forEach(button => button.addEventListener('click', () => {
      category = button.dataset.category; subtype = 'sub_all'; failures = 0; update(true);
      const insideMore = more?.contains(button); closeMore(); if (insideMore) more.querySelector('summary').focus();
    }, { signal: abort.signal }));
    subbuttons.forEach(button => button.addEventListener('click', () => { subtype = button.dataset.subtype; failures = 0; update(true); }, { signal: abort.signal }));
    region.addEventListener('keydown', event => { if (event.key === 'Escape' && more?.open) { closeMore(); more.querySelector('summary').focus(); } }, { signal: abort.signal });
    document.addEventListener('click', event => { if (more?.open && !more.contains(event.target)) closeMore(); }, { signal: abort.signal });
    window.addEventListener('online', () => { if (!records) { failures = 0; update(false, category === 'all' && grid.children.length === batchSize); } }, { signal: abort.signal });
    window.addEventListener('pageshow', event => { if (event.persisted) { if (records) watch(); else update(false, category === 'all' && grid.children.length === batchSize); } });
    window.addEventListener('pagehide', event => { observer?.disconnect(); if (!event.persisted) { abort.abort(); clearTimeout(retryTimer); } });
    update(false, category === 'all');
  });
})();
